import React from 'react'
import { useIntl } from 'react-intl'
import { css, cx } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { useOrganization } from '../organization-licenses/api/use-organization'

const labelCss = css`
  color: ${theme.color.neutral50};
  padding-top: 8px;
`
const Container = ({ children }) => (
  <div
    className={css`
      display: flex;
      flex-grow: 1;
      flex-shrink: 0;
    `}
  >
    <span
      className={css`
        display: flex;
        flex-grow: 1;
      `}
    />
    {children}
  </div>
)

export function DefaultPolicyConfigLinkWrapper({
  invokedLink,
  organizationUuid
}: DefaultPolicyConfigLinkProps) {
  const { formatMessage } = useIntl()
  const { data, isLoading, isError } = useOrganization({
    organizationUuid,
    expandValue: 'freemium'
  })

  if (isLoading) {
    return (
      <Container>
        <span
          className={cx(
            labelCss,
            css`
              visible: hidden;
            `
          )}
        >
          {formatMessage({ id: 'title_working' })}
        </span>
      </Container>
    )
  }
  if (isError) {
    throw new Error('Failed getting current organization data')
  }

  return data?.freemium ? null : (
    <Container>
      <DefaultPolicyConfigLink invokedLink={invokedLink} />
    </Container>
  )
}

interface DefaultPolicyConfigLinkProps {
  organizationUuid: string
  invokedLink: string
}

export function DefaultPolicyConfigLink({
  invokedLink
}: Pick<DefaultPolicyConfigLinkProps, 'invokedLink'>) {
  const { formatMessage } = useIntl()

  return (
    <span className={labelCss}>
      {formatMessage(
        {
          id: 'detail_policyManagement_configureDefaultPolicy'
        },
        {
          a: (msg) => <a href={invokedLink}>{msg}</a>
        }
      )}
    </span>
  )
}
